import axios from 'axios';
import { BaseAPI } from './BaseAPI';

export class GovFileAPI extends BaseAPI {
  /*商社通接口 */

  //上傳文件
  async govUploadFile(body, isApp = true) {
    const { data } = await axios.post(
      `${this._getBasePathPublic()}/association-business/${isApp}/upload`,
      body
    );
    return data;
  }

  //刪除文件
  async govDeleteDocument(ids, isApp = true) {
    const { data } = await axios.delete(
      `${this._getBasePathPublic()}/association-business/${isApp}/delete?ids=${ids}`
    );
    return data;
  }

  //刪除全部文件
  async govDeleteDocumentAll(applicationNo, typeIndex, isApp = true) {
    const { data } = await axios.delete(
      `${this._getBasePathPublic()}/association-business/${isApp}/deleteAll?applicationNo=${applicationNo}&typeIndex=${typeIndex}`
    );
    return data;
  }

  //獲取全部文件
  async govGetDocumentType(applicationType, companyType, isApp = true) {
    const { data } = await axios.get(
      `${this._getBasePathPublic()}/association-business/${isApp}/type/${applicationType}/${companyType}`
    );
    return data;
  }
  //根据文件ID获取文件内容
  async getDocumentById(id, isApp = true) {
    const { data } = await axios.get(
      `${this._getBasePathPublic()}/association-business/${isApp}/content/${id}`
    );
    return data;
  }

  //下载临时文件
  async getTempDownload(id, isApp = true) {
    const { data } = await axios.get(
      `${this._getBasePathPublic()}/association-business/${isApp}/temp/download?id=${id}`
    );
    return data;
  }

  //多人认证-资料互连
  async interconnectUpload(value, isApp = true) {
    const { data } = await axios.post(
      `${this._getBasePathPublic()}/association-business/${isApp}/interconnectUpload`,
      value
    );
    return data;
  }

  //邮寄上传
  async mailingUpload(value, isApp = true) {
    const { data } = await axios.post(
      `${this._getBasePathPublic()}/association-business/${isApp}/mailingUpload`,
      value
    );
    return data;
  }
}
export default new GovFileAPI({
  prefix: '',
  path: '/mo/document',
});
